import Component from './ProductFormRadioWithSubContent';

export default Component;
